import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-folder",
  "use": "foquz-icon-folder-usage",
  "viewBox": "0 0 17 15",
  "content": "<symbol viewBox=\"0 0 17 15\" fill=\"none\" id=\"foquz-icon-folder\"><path d=\"M14.31 3.7H9.28a.773.773 0 01-.643-.33l-1.1-1.54a.773.773 0 00-.643-.33H3.42c-.86 0-1.555.67-1.555 1.5v9c0 .83.695 1.5 1.555 1.5h10.89c.86 0 1.555-.67 1.555-1.5V5.2c0-.82-.695-1.5-1.556-1.5z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol